import { ImagesIcon, UploadSimpleIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import * as S from './dropzone.styled'
import { DropzoneProps } from './dropzone.types'

export const Dropzone = ({
  disabled,
  atCapacity,
  componentState,
  multiple,
  showBrowseLibrary,
  onBrowseLibrary,
  onInputClick,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
}: DropzoneProps) => {
  const effectiveAtCapacity = atCapacity && multiple

  const handleClick = (): void => {
    if (!disabled && !effectiveAtCapacity) {
      onInputClick()
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.code === 'Enter' || e.code === 'Space') {
      e.preventDefault()
      handleClick()
    }
  }

  const handleBrowseLibraryClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    onBrowseLibrary?.()
  }

  return (
    <S.Container
      $state={componentState}
      $atCapacity={effectiveAtCapacity}
      data-disabled={disabled}
      data-at-capacity={effectiveAtCapacity}
      data-drag={componentState === 'drag-over'}
      tabIndex={disabled ? -1 : 0}
      role="button"
      aria-label={multiple ? 'Upload files' : 'Upload file'}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <S.IconTextGroup>
        <S.IconBox $disabled={disabled || effectiveAtCapacity}>
          <Icon icon={UploadSimpleIcon} size="2rem" color="white" />
        </S.IconBox>
        <Typography
          size="text-large"
          color={disabled || effectiveAtCapacity ? 'black300' : 'black800'}
          textAlign="center"
        >
          Click here to upload or Drag and Drop
        </Typography>
      </S.IconTextGroup>

      {showBrowseLibrary && (
        <>
          <Typography
            size="text-large"
            color={disabled || effectiveAtCapacity ? 'black300' : 'black800'}
            textAlign="center"
          >
            or
          </Typography>
          <S.BrowseLibraryButton
            use="primary"
            size="medium"
            disabled={disabled || effectiveAtCapacity}
            onClick={handleBrowseLibraryClick}
          >
            Browse library
            <Icon icon={ImagesIcon} />
          </S.BrowseLibraryButton>
        </>
      )}
    </S.Container>
  )
}
